// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3ueKw","vLegacy":"SelectSecondary_vLegacy__2JGv-","error":"SelectSecondary_error__jKMUv","disabled":"SelectSecondary_disabled__6Rhzb"};